'use strict';
import forEach from 'lodash/forEach';
import isFunction from 'lodash/isFunction';
import moment from 'moment';
import {logger} from './logger';


export class DatePicker {
  /**
   * @param {Function} onSelect
   * @param {Number} [initialValue]
   */
  constructor(onSelect, initialValue) {
    this.dateOffsets = [0, 0];
    this.value = initialValue;
    this.onSelect = onSelect;
  }

  /**
   * step month, year, selected date, set date callback
   * @param month
   * @param year
   */
  init(month, year) {
    let now, nowYear, nowMonth, nowWeek;
    let startDate, startWeek, currentDay, d, w, date, days;
    try {

      // default stepper increments
      month = month || 0;
      year = year || 0;

      // client local timestamp
      now = moment();
      nowYear = now.year();
      nowMonth = now.month();
      nowWeek = now.week();

      if (month === 0 && year === 0) {
        this.selected = moment(this.value || new Date());
        this.dateOffsets[0] = this.selected.month() - nowMonth;
        this.dateOffsets[1] = this.selected.year() - nowYear;
      } else {
        this.dateOffsets[0] += month;
        this.dateOffsets[1] += year;
      }


      startDate = now.add('M', this.dateOffsets[0]).add('y', this.dateOffsets[1]);
      startWeek = startDate.date(1).week();
      currentDay = startDate.date();

      // column headings - this can live outside init() but needs to trigger on language change
      this.daysOfWeek = [];
      for (d = 0; d < 7; d++) {
        this.daysOfWeek.push(now.day(d).format('dd'));
      }

      // generate calendar model
      this.viewTitle = startDate.format('MMMM YYYY');
      this.weeks = [];
      // 7 rows in calendar - add days for each row
      for (w = startWeek; w < startWeek + 6; w++) {
        date = moment(startDate).week(w);
        days = [];
        for (d = 0; d < 7; d++) {
          days.push({
            date: moment(date.day(d)),
            day: date.day(d).format('D'),
            active: _isActiveMonth(date),
            today: _isCurrentMonth(date, w) && date.date() === currentDay,
            selected: this.selected.format('DD/MM/YYYY') === moment(date.day(d)).format('DD/MM/YYYY')
          });
        }
        this.weeks.push({week: w, current: _isCurrentMonth(date, w), days: days});
      }

      //console.log('completed picker virtual-render:', this)
    } catch (err) {
      logger.error({err}, 'DatePicker.init failed to update with exception');
    }

    // TODO: was forcing showModal to true. need to make sure the modal is open with $modal service

    function _isCurrentMonth(date, w) {
      return nowYear === date.year() && nowWeek === w;
    }

    function _isActiveMonth(date) {
      return startDate.year() === date.year() && startDate.month() === date.month();
    }
  }

  setSelected(day) {
    if (day.active) {
      const sel = moment(this.selected);
      forEach(this.weeks, week => {
        for (let d = 0; d < 7; d++) {
          week.days[d].selected = week.days[d].date === day.date;
        }
      });
      // set preferred return format here - valueOf() = Unix offset milliseconds
      this.selected = day.date.hour(sel.hour()).minute(sel.minute()).seconds(0);
    }
  }

  select() {
    this.value = new Date(this.selected.valueOf());
    if (isFunction(this.onSelect)) this.onSelect(this.value);
  }

  clear() {
    this.value = null;
    if (isFunction(this.onSelect)) this.onSelect(this.value);
  }

  today() {
    const sel = moment(this.selected);
    this.value = moment().hour(sel.hour()).minute(sel.minute()).seconds(0);
    this.init();
  }
}



// WEBPACK FOOTER //
// ./src/js/core-components/android-date-time-pickers/DatePicker.js